import React from 'react';

import PropTypes from 'prop-types';
import { DesiredOutcomeContextProvider } from './Context';
import Container from './Container';

const DesiredOutcomesComponent = ({ tabDataRelationship }) => {
  return (
    <DesiredOutcomeContextProvider relationship={tabDataRelationship}>
      <Container />
    </DesiredOutcomeContextProvider>
  );
};

DesiredOutcomesComponent.propTypes = {
  tabDataRelationship: PropTypes.object.isRequired,
};

export default DesiredOutcomesComponent;
